import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'components/Modal/Modal';
import { BUTTON_VARIANT } from 'constants/interfaces';

import type IScenarioShowcaseDeleteModal from './interfaces/IScenarioShowcaseDeleteModal';

function ScenarioShowcaseDeleteModal({
  isOpen,
  isLoading,
  scenarioName,
  onReject,
  onConfirm,
}: IScenarioShowcaseDeleteModal): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <Modal
      open={isOpen}
      title={t('valueChainMap.deleteScenarioTitle', { name: scenarioName })}
      description={t('valueChainMap.deleteScenarioDescription')}
      closeTitle={t('valueChainMap.deleteScenarioCancel')}
      confirmTitle={t('valueChainMap.deleteScenarioConfirm')}
      confirmVariant={BUTTON_VARIANT.error}
      onReject={onReject}
      onConfirm={onConfirm}
      isLoading={isLoading}
    />
  );
}

export default ScenarioShowcaseDeleteModal;
